export default __webpack_public_path__ + "static/media/placeholder_dummy2016-haushalthilfe01-de.84542e79.png";